import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import api from "../../api.js";

const DashboardIdeas = () => {
  const [ideas, setIdeas] = useState([]);
  const token = Cookies.get("access_token");

  useEffect(() => {
    api.get("/idea/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setIdeas(res.data);
      })
      .catch((err) => {
        console.error("Error fetching ideas", err);
      });
  }, []);

  return (
    <div className="container">
      {ideas.length === 0 ? (
        <p>هیچ ایده‌ای ثبت نشده است.</p>
      ) : (
        <div className="row">
          {ideas.map((idea) => (
            <div className="col-12 col-md-6 col-lg-4 mb-3" key={idea.id}>
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">{idea.title}</h5>
                  <p className="card-text text-truncate">{idea.description}</p>
                  <p className="card-text">
                    <small className="text-muted">
                      تاریخ ایجاد: {new Date(idea.created_at).toLocaleDateString('fa-IR')}
                    </small>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardIdeas;
